import {
  ServerUtility,
  vsName as serverUtilityName,
} from "../../../../../../records/server/serverUtility";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../../../components/machineDetailTabs";
import { Machine } from "../../../../models/machine";
import { vsComponentName as MachineDetailProgressiveConfigurationComponentName } from "./component";

machineDetailProgressiveComponentConfig.$inject = [
  MachineDetailTabsProviderName,
];
export function machineDetailProgressiveComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addTabConfig({
    displayName: "Progressive Configuration",
    id: "progressiveConfiguration",
    uiSrefFragment: "progressiveConfiguration",
    requiredPermission: "partView",
    stateDefinition: {
      url: "/progressiveConfiguration",
      component: MachineDetailProgressiveConfigurationComponentName,
      resolve: {
        machine: ["machine", (machine: Machine) => machine],
        progressiveInformation: [
          "machine",
          serverUtilityName,
          (machine: Machine, serverUtility: ServerUtility) => {
            const configurations = machine.Configs ?? [];
            const configurationIds = configurations.map((c) => c.Id);
            return serverUtility
              .sendApiRequest({
                method: "POST",
                url: "/api/machines/MachineConfiguration/progressiveInformation",
                data: {
                  MachineConfigurationIds: configurationIds,
                },
              })
              .then((r: any) => r.Result);
          },
        ],
      },
    },
  });
}
